<template>
  <div>
    <div class="btn-copy">
      <b-button
        v-clipboard:copy="value"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        v-b-tooltip.hover.top="`${$t('form.copy')} ${$t('banners.targetings.sites')}`"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="outline-primary"
        size="sm"
      >
        <feather-icon icon="CopyIcon" />
      </b-button>
    </div>
    <b-form-tags
      v-model="tagList"
      tag-variant="primary"
      separator=","
      class="w-100"
      add-on-change
      remove-on-delete
      placeholder="Add Site ID"
      @tag-state="validateTag"
      @input="handleInputChange"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { BButton, BFormTags, VBTooltip } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'SiteSelectorTags',
  components: {
    BFormTags,
    BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tagList: [],
    }
  },
  computed: {
    ...mapGetters('dashboard-sites-stats', ['siteNameByIdFromStore']),
  },
  watch: {
    value: {
      immediate: true,
      async handler(ids) {
        if (!Array.isArray(ids) || !ids.length) {
          this.tagList = []
          return
        }

        await this.fetchSiteNamesById(ids)

        const idToNameMap = Object.fromEntries(
          this.$store.state['dashboard-sites-stats'].siteNames.map(s => [s.id, s.name]),
        )

        this.tagList = ids.map(id => idToNameMap[id] || id)
      },
    },
  },
  methods: {
    ...mapActions('dashboard-sites-stats', ['fetchSiteNamesById']),
    async validateTag(tag) {
      const input = String(tag).trim()
      const isPossibleId = /^[a-f0-9]{24}$/.test(input)

      const allSites = this.$store.state['dashboard-sites-stats'].siteNames
      const nameToIdMap = Object.fromEntries(allSites.map(s => [s.name.toLowerCase(), s.id]))
      const idToNameMap = Object.fromEntries(allSites.map(s => [s.id, s.name]))

      if (idToNameMap[input] || nameToIdMap[input.toLowerCase()]) {
        return true
      }

      if (isPossibleId) {
        await this.fetchSiteNamesById([input])
        const updated = this.$store.state['dashboard-sites-stats'].siteNames.find(s => s.id === input)
        return !!updated
      }

      return false
    },
    handleInputChange(tags) {
      const allSites = this.$store.state['dashboard-sites-stats'].siteNames
      const nameToIdMap = Object.fromEntries(allSites.map(s => [s.name.toLowerCase(), s.id]))
      const idToNameMap = Object.fromEntries(allSites.map(s => [s.id, s.name]))
      const ids = tags.map(t => {
        if (idToNameMap[t]) return t
        if (nameToIdMap[t.toLowerCase?.()]) return nameToIdMap[t.toLowerCase()]
        return null
      }).filter(Boolean)

      const finalIds = [...new Set(ids)]

      this.$emit('input', finalIds)
      this.tagList = finalIds.map(id => idToNameMap[id] || id)
    },
    onCopy() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Sites copied',
          icon: 'BellIcon',
        },
      })
      this.$refs.tarea.focus()
      this.$refs.tarea.select()
    },
    onError() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Failed to copy sites!',
          icon: 'BellIcon',
        },
      })
    },
  },
}
</script>
<style scoped>
.btn-copy {
  position: absolute;
  top: 20px;
  right: 20px;
}
</style>
<style>
[dir] .partner-sites {
  position: relative;
}

[dir] .partner-sites .btn-copy {
  right: 0;
}
</style>
